import * as ReactRedux from 'react-redux';
import { push } from 'react-router-redux';
import { paths } from '../app/app.routes';
import PosHistoryComponent from './PosHistoryComponent';
import { AppState } from '../app/app.types';
import { getPosHistories, refund } from './Actions';
import { GetPosHistoriesRequest, RefundPosRequest } from './Types';

const mapDispatchToProps = (dispatch) => {
  return {
    toAdminDashboard: () => dispatch(push(paths.adminDashboard)),
    toDashboard: () => dispatch(push(paths.dashboard)),
    getPosHistories: (req: GetPosHistoriesRequest) => dispatch(getPosHistories(req)),
    refund: (req: RefundPosRequest) => dispatch(refund(req)),
    toPosSaleResult: () => dispatch(push(paths.posSaleResult))
  };
};

const mapStateToProps = (state: AppState) => {
  return {
    authState: state.authState,
    adminState: state.adminState,
    posState: state.posState
  };
};

const PosHistory = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(PosHistoryComponent);

export default PosHistory;


// WEBPACK FOOTER //
// ./src/pos/PosHistory.tsx